import Cookies from 'js-cookie';
import {Locale} from 'types';

const isEnglish = (value?: string) =>
    value &&
    [
        'eng',
        'english',
        'en',
        'en-au',
        'en-bz',
        'en-ca',
        'en-ie',
        'en-jm',
        'en-nz',
        'en-ph',
        'en-za',
        'en-tt',
        'en-gb',
        'en-us',
        'en-zw',
    ].includes(value.toLowerCase());

const isJapanese = (value?: string) =>
    value && ['japanese', 'japan', 'ja', 'ja-JP'].includes(value.toLowerCase());

const getPreferredLanguage = (): Locale => {
    let language = Cookies.get('django_language');
    if (isJapanese(language)) return 'ja';
    if (isEnglish(language)) return 'en';

    language = navigator.language;
    if (isJapanese(language)) return 'ja';
    if (isEnglish(language)) return 'en';

    return 'ja';
};

export default getPreferredLanguage;
